import { createMmBackendClient } from "../utils/create-mm-backend-client";
import { useFrontendContext } from "./use-frontend-context";

export const useMmBackendClient = () => {
  const frontendContext = useFrontendContext();
  return createMmBackendClient(frontendContext);
};
